module.exports = __webpack_public_path__ + "fonts/Montserrat-ThinItalic.ff07fc8d.ttf";